import { IconV2 } from 'components/common/IconV2/IconV2';
import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';

const SwapIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <path
      stroke="currentcolor"
      strokeLinecap="round"
      d="M3.806 13.84C3.806 8.593 6.056 4 12.94 4h5.218c6.883 0 9.133 4.592 9.133 9.84m0 0-2.71-2.614m2.71 2.614L30 11.227M27.29 18.452c0 5.248-2.172 9.84-8.818 9.84h-5.038c-6.646 0-8.818-4.592-8.818-9.84m0 0 2.616 2.614m-2.616-2.614L2 21.066"
    />
  </IconV2>
);

export default SwapIcon;
